import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Formik } from "formik";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";
import React, { useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";

import GroupService from "@services/Group";

import {
  NINTH_DIGIT_PHONE_MASK,
  CELL_PHONE_MASK,
  unformatPhone,
} from "@utils/form";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "520px",
    maxWidth: "100%",
    overflow: "visible",
    boxSizing: "border-box",
  },
}));

function phoneInputMask(value) {
  if (!value || unformatPhone(value).length !== 11) {
    return NINTH_DIGIT_PHONE_MASK;
  }
  return CELL_PHONE_MASK;
}

function GroupNumberSelector(props) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);

  function addNumberToGroup(values, callback) {
    setLoading(true);
    GroupService.addContact(props.listId, unformatPhone(values.phoneNumber))
      .then(() => {
        toast.success("Número de telefone adicionado!");
        setLoading(false);
        callback();
      })
      .catch((e) => {
        console.error(e);
        toast.error("Erro ao adicionar número de telefone!");
        setLoading(false);
      });
  }

  const initialValues = {
    phoneNumber: "",
  };
  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .test("", "Campo obrigatório", (value, context) => {
        if (typeof value === "undefined") {
          return false;
        }
        if (
          typeof value === "string" &&
          (value.length === 0 || value === "(  )     -     ")
        ) {
          return false;
        }
        return true;
      })
      .test("", "Número inválido", (value, context) => {
        if (typeof value === "undefined") {
          return false;
        }

        if (
          /\(\d{2}\)\s\d{4}-\d{4}/g.test(value) ||
          /\(\d{2}\)\s9\d{4}-\d{4}/g.test(value) ||
          /\(\d{2}\)\s\d{5}-\d{3}/g.test(value)
        ) {
          return true;
        }

        return false;
      }),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnMount
      isInitialValid={false}
    >
      {(context) => {
        const {
          errors,
          touched,
          isValid,
          values,
          resetForm,
          handleChange,
          handleBlur,
        } = context;

        function handleClickClose() {
          if (!loading) {
            props.onCancel();
            resetForm();
          }
        }

        function handleClickCancel() {
          props.onCancel();
          resetForm();
        }

        function handleClickAdd() {
          addNumberToGroup(values, () => {
            props.onSuccess();
            resetForm();
          });
        }

        return (
          <Dialog
            open={props.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClickClose}
          >
            <DialogTitle>Adicionar número de telefone</DialogTitle>

            <DialogContent className={classes.dialogContent}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputMask
                    mask={phoneInputMask(values.phoneNumber)}
                    maskChar=" "
                    value={values.phoneNumber}
                    variant="outlined"
                    fullWidth
                    label="Número de Telefone"
                    name="phoneNumber"
                    required={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {(props) => (
                      <TextField
                        {...props}
                        helperText={
                          touched.phoneNumber ? errors.phoneNumber : ""
                        }
                        error={
                          touched.phoneNumber && Boolean(errors.phoneNumber)
                        }
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>
            </DialogContent>

            {/* control */}
            <DialogActions>
              <Button disabled={loading} onClick={handleClickCancel}>
                Cancelar
              </Button>
              <Button
                disabled={!isValid || loading}
                onClick={handleClickAdd}
                color="primary"
              >
                Adicionar
              </Button>
            </DialogActions>
            {/* end control */}
          </Dialog>
        );
      }}
    </Formik>
  );
}

GroupNumberSelector.propTypes = {
  open: PropTypes.bool.isRequired,
  listId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

GroupNumberSelector.defaultProps = {
  open: false,
  listId: "",
  onCancel: () => {},
  onSuccess: () => {},
};

export default GroupNumberSelector;
